export default __webpack_public_path__ + "static/alberto1-3e8ab9d0b0c572a7cb3c1378735e770a.png";